<template>
  <div class="FormTopicScaffold">
    <Field
      :label="$t('textarea')"
      required
      type="textarea"
      :value="blueprintsJson"
      @update:value="setBlueprints" />
  </div>
</template>

<script>
import { always, pipe, tryCatch } from 'rambda'
import { convertPasteToJson, isPastedSpreadsheet } from '@store/modules/articleBlueprint'

export default {
  props: {
    value: Array,
  },
  data() {
    return {
      blueprintsJson: '',
      error: null,
    }
  },
  methods: {
    setBlueprints(blueprintsJson) {
      try {
        if (isPastedSpreadsheet(blueprintsJson)) {
          blueprintsJson = pipe(
            convertPasteToJson,
            JSON.stringify,
          )(blueprintsJson)
        }

        const blueprints = JSON.parse(blueprintsJson)

        if (!Array.isArray(blueprints)) {
          throw new TypeError('Expected blueprints to be an array')
        }

        this.$up('value', blueprints)
        this.error = null
      } catch (error) {
        this.error = error
      }
    },
  },
  watch: {
    value(value) {
      this.blueprintsJson = tryCatch(JSON.stringify, always(''))(value)
    },
  },
}
</script>

<style lang="scss">
.FormTopicScaffold {}
</style>

<i18n>
{
  "en": {
    "textarea": "Topics blueprint"
  }
}
</i18n>
